import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core'

@Component({
    selector: 'app-welcome-back-popup',
    templateUrl: './welcome-back.component.html',
    styleUrls: ['./welcome-back.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WelcomeBackPopupComponent implements OnInit {
  constructor() {}
  @Input() withContinue: boolean
  @Input() multiLoan: boolean
  @Input() lassSession: string
  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Output() closed: EventEmitter<unknown> = new EventEmitter()

  close() {
    this.closed.emit(true)
  }

  ngOnInit(): void {
  }

}
